import * as core from '../../../../../../../core'

import { query } from './explore-trends-updated-org-structure.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.explore.widgets.trends',
    description:
      'Version of Trends widget that accounts for Institution, Organization, and PI Lenses',
    name: 'RP Explore - Trends',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
